import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@base-app';
import { CardGrid } from '@builder';
import { ChartReferences } from '@builder/organisms/Charts/ChartReferences';
import { colors, STUDY_INSIGHTS_TRANSLATION } from '@modules/study-insights/constants';
import { DemographicsListViewProps } from './DemographicsListView.types';
import { StyledDemographicsContainer, StyledLeftContainer, StyledRightContainer } from './DemographicsListView.styles';

import DemographicsBarChart from '../DemographicsBarChart/DemographicsBarChart';
import { PieChart } from '@charts';

const BLUE = [
  colors.blue700,
  colors.blue800,
  colors.blue200,
  colors.blue300,
  colors.blue400,
  colors.blue500,
  colors.blue100,
  colors.blue600,
];

const YELLOW = [
  colors.yellow700,
  colors.yellow800,
  colors.yellow200,
  colors.yellow300,
  colors.yellow400,
  colors.yellow500,
  colors.yellow100,
  colors.yellow600,
];

const PINK = [colors.pink200, colors.pink300, colors.pink400, colors.pink500, colors.pink100, colors.pink600];

const DemographicsListView: FC<DemographicsListViewProps> = ({ data }) => {
  const { t } = useTranslation(STUDY_INSIGHTS_TRANSLATION);

  return (
    <Box data-testid="demographics-list-view">
      <StyledDemographicsContainer
        css={{
          marginBottom: '$6',
        }}
      >
        <StyledLeftContainer>
          <CardGrid css={{ paddingBottom: '$8' }} title={t('demographics.race')}>
            <PieChart data={data.byRaceEthnicity} chartColors={BLUE} />
            <ChartReferences data={data.byRaceEthnicity} referencesColors={BLUE} />
          </CardGrid>
        </StyledLeftContainer>
        <StyledRightContainer>
          <CardGrid css={{ paddingBottom: '$8' }} title={t('demographics.preferred_language')}>
            <PieChart data={data.byPreferredLanguage} chartColors={YELLOW} />
            <ChartReferences data={data.byPreferredLanguage} referencesColors={YELLOW} />
          </CardGrid>
        </StyledRightContainer>
      </StyledDemographicsContainer>
      <StyledDemographicsContainer>
        <StyledLeftContainer>
          <CardGrid css={{ paddingBottom: '$8' }} title={t('demographics.age_range')}>
            <DemographicsBarChart data={data.byAgeRange} />
          </CardGrid>
        </StyledLeftContainer>
        <StyledRightContainer>
          <CardGrid css={{ paddingBottom: '$8' }} title={t('demographics.sex_at_birth')}>
            <PieChart data={data.byBiologicalSex} chartColors={PINK} />
            <ChartReferences data={data.byBiologicalSex} referencesColors={PINK} />
          </CardGrid>
        </StyledRightContainer>
      </StyledDemographicsContainer>
    </Box>
  );
};

export default DemographicsListView;
